import "react-quill-new/dist/quill.snow.css";
import "./RichTextEditor.css";

interface RichTextContentProps {
  html: string;
  className?: string;
}

// Renders HTML saved from RichTextEditor. Quill's own bundled theme CSS
// (headings, font/size classes, alignment, list markers via `.ql-ui`
// counters, link styling) is scoped to a `.ql-container.ql-snow > .ql-editor`
// DOM shape — reusing that exact shape here, instead of hand-replicating a
// subset of those rules, is what makes every formatting option the editor
// supports also render correctly wherever the saved content is shown.
export default function RichTextContent({ html, className }: RichTextContentProps) {
  return (
    <div className={`ql-container ql-snow rich-text-content ${className || ""}`}>
      <div className="ql-editor" dangerouslySetInnerHTML={{ __html: html }} />
    </div>
  );
}
